import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Jcktk } from '../entity/Jcktk-angular';


@Injectable({
  providedIn: 'root'
})
export class JcktkServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Jcktk();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      TK001: '單號', TK002: '日期', TK003: '使用者', TK005: '自訂分類', TK006: '問題', TK007: '回答', TK008: '問題token數', TK009: '回答token數'
    };

    this.fieldNames = 'TK001,TK002,TK003,TK005,TK006,TK007,TK008,TK009';
    this.fieldLengths = { TK001: 20, TK002: 8, TK003: 10, TK005: 20, TK006: 0, TK007: 0, TK008: 6, TK009: 6 };
    this.columnDefs = [
      { field: "TK001", headerName: "單號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TK002", headerName: "日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "TK003", headerName: "使用者", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TK005", headerName: "自訂分類", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TK006", headerName: "問題", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TK007", headerName: "回答", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TK008", headerName: "問題token數", headerTooltip: "", width: 118, cellDataType: "number", },
      { field: "TK009", headerName: "回答token數", headerTooltip: "", width: 118, cellDataType: "number", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'JCKTK';
    this.isSys = false;
    this.sqlSelect = `SELECT *  FROM JCKTK`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY TK001 DESC`;
    this.keyFields = ['TK001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['TK001'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Jcktk): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Jcktk): Promise<Jcktk> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
